import { css } from '@emotion/react';
import type { ComponentPropsWithoutRef } from 'react';
import { useProgressContext } from './context';

export type ProgressSecondaryLabelProps = ComponentPropsWithoutRef<'span'>;

// TODO: Review once we have Typography component
const baseStyle = css({
  fontFamily: 'var(--atlasUiFontFamilyDefault)',
  color: 'var(--color-text-low)',
  fontWeight: 400,
});

const largeStyle = css({
  fontSize: 'var(--fontSize30)',
});

const mediumStyle = css({
  fontSize: 'var(--fontSize20)',
});

const hideStyle = css({
  display: 'none',
});

export const ProgressSecondaryLabel = ({
  children,
  ...restProps
}: ProgressSecondaryLabelProps) => {
  const { size } = useProgressContext();
  const isLarge = size === 'large';
  const isMedium = size === 'medium';
  const isSmallerThanMedium =
    size === 'small' || size === 'xsmall' || size === 'mini';

  return (
    <span
      css={[
        baseStyle,
        isLarge && largeStyle,
        isMedium && mediumStyle,
        isSmallerThanMedium && hideStyle,
      ]}
      {...restProps}
    >
      {children}
    </span>
  );
};
